import MSpinnerBall from "./MSpinnerBall.vue";
export default MSpinnerBall;
export type { MSpinnerBallProps } from "./MSpinnerBall.props";
